module.exports = __webpack_public_path__ + "img/OurServiceAI_pic1.e1dd7cb7.png";